import { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Command, CommandInput, CommandList, CommandEmpty, CommandItem } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";

// Durchsuchbares Dropdown (wie die Produktsuche) – options: [{value, label}]
export function SearchSelect({ options, value, onChange, placeholder, testId, className }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const sel = options.find((o) => o.value === value);
  const ph = placeholder || t("common.select");
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox" data-testid={testId}
          className={cn("w-full min-w-0 justify-between font-normal", className)} title={sel ? sel.label : undefined}>
          <span className="truncate">{sel ? sel.label : ph}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-auto min-w-[320px] max-w-[560px]" align="start">
        <Command>
          <CommandInput placeholder={t("common.searchSkuName")} data-testid={testId ? `${testId}-search` : undefined} />
          <CommandList onWheel={(e) => { e.currentTarget.scrollTop += e.deltaY; }}>
            <CommandEmpty>{t("common.noHit")}</CommandEmpty>
            {options.map((o) => (
              <CommandItem key={o.value} value={o.label} onSelect={() => { onChange(o.value); setOpen(false); }} title={o.label}>
                <Check className={cn("mr-2 h-4 w-4 shrink-0", value === o.value ? "opacity-100" : "opacity-0")} />
                <span className="whitespace-normal leading-snug break-words">{o.label}</span>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
